import React from 'react'
import { useSelector } from 'react-redux'

const Instructions = () => {
  const { questions } = useSelector((state) => state.models)

  const getQuestion = () => {
    switch (questions) {
      case 1:
        return (
          <div className='ModelSelector__instructions__ask'>
            <p className='ModelSelector__instructions__ask__title'>Step {questions}</p>
            <p className='ModelSelector__instructions__ask__question'>
              Choose the option
            </p>
          </div>
        )
      case 2:
        return (
          <div className='ModelSelector__instructions__ask'>
            <p className='ModelSelector__instructions__ask__title'>Step {questions}</p>
            <p className='ModelSelector__instructions__ask__question'>
              How many screens would you like?
            </p>
          </div>
        )
      case 3:
        return (
          <div className='ModelSelector__instructions__ask'>
            <p className='ModelSelector__instructions__ask__title'>Step {questions}</p>
            <p className='ModelSelector__instructions__ask__question'>Would you like a canopy?</p>
          </div>
        )
      default:
        return null
    }
  }

  return <div className='ModelSelector__instructions'>{getQuestion()}</div>
}

export default Instructions
